import {BaseDtoModel} from '../../../Services/Models/base-model.service';

export class TransferFilters extends BaseDtoModel {
  local_origen!: number;
  local_destino!: number;
  dias_atras!: number;
  id_estado!: number;
  recibidos!: boolean;

  constructor(dataJson?: any) {
    super(dataJson);

    this.init({
      local_origen: 0,
      local_destino: 0,
      dias_atras: 30,
      recibidos: false,
      id_estado: 0,
    });
  }
}
